import { useTypeTicketCollectionBulkData } from 'hooks/useTypeTicketCollection'

import CollectionDataFetcher from './CollectionDataFetcher'

interface Props {
  typeticketIds: number[]
}

const TypeTicketCollectionToCollectionBridge: React.FC<Props> = (props: Props) => {
  const { typeticketIds } = props

  const data = useTypeTicketCollectionBulkData({ ids: typeticketIds })

  if (typeticketIds.length === 0 || !data || data.length != typeticketIds.length) {
    return null
  }

  const codes = [...new Set(data.map((item) => item.eventCollection.code))]

  return <CollectionDataFetcher codes={codes} />
}

export default TypeTicketCollectionToCollectionBridge
